module.exports = __webpack_public_path__ + "assets/img/Bowler.png?2f41f069037a2d6fee4fc4228cb28b01";